import React from 'react';
import DatepickerStyled from 'components/DatepickerStyled';
import InputStyled from 'components/InputStyled';
import dayjs from 'dayjs';
import dateFormat from 'utils/helper/dateFormat';
import moment from 'moment';

interface IProps {
  type: any;
  data: any | null;
  detailData: any;
  index: number;
  setData: React.Dispatch<any>;
}

const ConditionInput: React.FC<IProps> = ({
  type,
  data,
  detailData,
  index,
  setData,
}) => {
  const handleChange = (value) => {
    const cloneData = JSON.parse(JSON.stringify(data));
    const cloneDetailData = JSON.parse(JSON.stringify(detailData));
    cloneDetailData['line_condition'] = value;
    cloneData.lines[index] = cloneDetailData;
    setData(cloneData);
  };

  return (
    <>
      {type ? <p className='title'>Ability</p> : <></>}

      {type === 0 ? (
        <></>
      ) : type === 1 ? (
        <InputStyled
          value={data?.lines[index]?.line_condition}
          onChange={(e) => {
            handleChange(e.target.value);
          }}
        />
      ) : (
        <DatepickerStyled
          value={
            data?.lines[index]?.line_condition
              ? dayjs(
                  moment(data?.lines[index]?.line_condition).format(
                    'YYYY-MM-DD',
                  ),
                  dateFormat,
                )
              : null
          }
          format={dateFormat}
          onChange={(date, dateString) => {
            const newDate = new Date(dateString);
            const formattedDate = newDate.toISOString();
            handleChange(formattedDate);
          }}
        />
      )}
    </>
  );
};

export default ConditionInput;
